// extracted by mini-css-extract-plugin
export default {"rootClassName":"contrato-atividades"};